// const BASE_URL = 'http://139.59.30.209:8083'
// const BASE_URL = 'http://10.0.0.19:8083'
const BASE_URL = 'https://api.tc.parkoye.com'

export { BASE_URL }
